const MAIN_DOMAIN = 'obratycoon.com.br'

/**
 * Subdomínio dedicado do painel /administrador (master).
 * Em produção o painel só é acessível em valdisnei.obratycoon.com.br.
 * Este username fica reservado no backend (nenhuma obra pode adotá-lo).
 */
export const MASTER_SUBDOMAIN = 'valdisnei'

/** true em ambiente de desenvolvimento local (localhost / rede local). */
export function isLocalHost(): boolean {
  const h = window.location.hostname
  return (
    h === 'localhost' ||
    h === '127.0.0.1' ||
    h.startsWith('192.168.') ||
    h.startsWith('10.')
  )
}

/**
 * true quando o contexto atual PODE acessar o painel /administrador (master):
 * - Dev/localhost: sempre (acesso via /valdisnei ou /administrador).
 * - Produção: apenas no subdomínio dedicado (valdisnei.obratycoon.com.br).
 */
export function isMasterContext(): boolean {
  if (isLocalHost()) return true
  return getSubdomainUsername() === MASTER_SUBDOMAIN
}

/**
 * true SOMENTE quando estamos de fato no subdomínio dedicado do painel
 * (valdisnei.obratycoon.com.br) — diferente de isMasterContext(), NÃO inclui
 * localhost. Usado para desviar a raiz/login desse subdomínio direto pro painel,
 * em vez de tratar "valdisnei" como uma obra.
 */
export function isMasterSubdomain(): boolean {
  return getSubdomainUsername() === MASTER_SUBDOMAIN
}

/**
 * Returns the systemUsername from the subdomain, or '' if on main domain / localhost.
 * e.g. "minhaconstrutora.obratycoon.com.br" → "minhaconstrutora"
 */
export function getSubdomainUsername(): string {
  const hostname = window.location.hostname
  if (hostname.endsWith('.' + MAIN_DOMAIN)) {
    const sub = hostname.slice(0, hostname.length - MAIN_DOMAIN.length - 1)
    if (sub && sub !== 'www') return sub.toLowerCase()
  }
  return ''
}

export function isOnSubdomain(): boolean {
  return getSubdomainUsername() !== ''
}

/**
 * Returns the login URL for a given systemUsername.
 * On localhost/dev: stays as /login/:systemUsername (same-domain SPA)
 * On production: returns the full subdomain URL
 */
export function subdomainLoginUrl(systemUsername: string): string {
  const { hostname, protocol } = window.location
  const isLocal =
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.startsWith('192.168.') ||
    hostname.startsWith('10.')
  if (isLocal) {
    return `/login/${encodeURIComponent(systemUsername)}`
  }
  return `${protocol}//${systemUsername}.${MAIN_DOMAIN}/login`
}

/**
 * Returns the base URL of the app for a given systemUsername subdomain.
 * Used to redirect the full session to the correct subdomain after login.
 */
export function subdomainBaseUrl(systemUsername: string): string {
  const { hostname, protocol } = window.location
  const isLocal =
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.startsWith('192.168.') ||
    hostname.startsWith('10.')
  if (isLocal) return ''
  return `${protocol}//${systemUsername}.${MAIN_DOMAIN}`
}
